import { styled } from "@mui/material/styles";
import { Container } from "@mui/material";

export const StyledContainer = styled(Container)(({ theme }) => ({
  marginTop: 40,
  "& h1": {
    textAlign: "center",
    marginTop: 0,
    marginBottom: 15,
    fontSize: theme.typography.large.fontSize,
  },
  "& p": {
    textAlign: "center",
    fontSize: theme.typography.large.fontSize,
    maxWidth: 710,
    margin: "0 auto",
  },
}));
